import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import AppPage from "@/components/layout/AppPage.vue"
import { ClientInvoicesListQuery } from "@/gql"
import Icon from "@/components/widgets/icons/Icon.vue"
import EditBillingForm from "@/components/forms/EditBillingForm.vue"
import ConfirmPayment from "@/modules/Users/Billing/ConfirmPayment.vue"
import Table from "@/components/widgets/data/Table.vue"
import Modal from "@/components/widgets/common/Modal.vue"
import { useUtilities } from "@/hooks/useUtilities"


export default /*#__PURE__*/_defineComponent({
  __name: 'Billing',
  setup(__props) {

const query = ClientInvoicesListQuery
const loading = ref(false)

const headers = [
  {
    text: "Mission",
    value: "invoiceType",
    custom: true,
    sortable: false,
  },
  {
    text: "Description",
    value: "description",
    custom: true,
    sortable: false,
  },

  {
    text: "Status",
    value: "state",
    custom: true,
    sortable: false,
  },
  {
    text: "Amount",
    value: "amount",
    custom: true,
  },
  {
    text: "Due Date",
    value: "dueAt",
    custom: true,
  },
  {
    text: "",
    value: "download",
    sortable: false,
    custom: true,
  },
]

const showEditPayModal = ref(false)
const showConfirmPaymentModal = ref(false)

const { formatDate } = useUtilities()

const gotoPay = (url: string) => {
  window.open(url, "_blank")
}

return { __sfc: true,query, loading, headers, showEditPayModal, showConfirmPaymentModal, formatDate, gotoPay, AppPage, Icon, EditBillingForm, ConfirmPayment, Table, Modal }
}

})